import { useState } from 'react';
import { liteClient } from 'algoliasearch/lite';
import { Configure, InstantSearch, Stats } from 'react-instantsearch';
import SearchBox from './SearchBox';
import Hits from './Hits';
import { SearchAction } from './Models';
import { P2GBox, P2GGrid, P2GLink, P2GText } from '@parcel2go/core-ui';
import CustomRefinementList from './CustomRefinedList';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

export interface ISearchProps {
  client: ReturnType<typeof liteClient>;
  indexName: string;
  analtyicsTags?: string[];
  hit?: SearchAction;
  hideFilter?: boolean;
  hideSearch?: boolean;
}

const SearchPage: React.FC<ISearchProps> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [showFilter, setShowFilter] = useState(false);
  return (
    <InstantSearch searchClient={props.client} indexName={props.indexName}>
      <Configure
        analytics={true}
        clickAnalytics
        analyticsTags={props.analtyicsTags || ['ACCOUNT_HEADER']}
        hitsPerPage={10}
      />
      <P2GGrid container direction="column" spacing={2}>
        {!props.hideSearch && (
          <P2GGrid item xs={12}>
            <SearchBox />
          </P2GGrid>
        )}
        {!props.hideFilter && (
          <P2GGrid item>
            <P2GGrid container alignItems="center" spacing={2}>
              <P2GGrid item>
                <P2GText>
                  <strong>
                    <Stats />
                  </strong>
                </P2GText>
              </P2GGrid>
              <P2GGrid item>
                <P2GLink onClick={() => setShowFilter(!showFilter)}>
                  {showFilter ? (
                    <>{t('SEARCH_PAGE_REFINE_RESULTS_FILTER_HIDE', { defaultValue: 'Hide' })}</>
                  ) : (
                    <>{t('SEARCH_PAGE_REFINE_RESULTS_FILTER_SHOW', { defaultValue: 'Refine Results' })}</>
                  )}
                </P2GLink>
              </P2GGrid>
            </P2GGrid>
          </P2GGrid>
        )}
        <P2GGrid item>
          {!props.hideFilter && (
            <div style={{ display: showFilter ? 'block' : 'none' }}>
              <P2GBox p={2} bordered mb={2}>
                <P2GGrid container spacing={2}>
                  <P2GGrid item xs={6}>
                    <CustomRefinementList attribute="smartSend.sources" limit={5} searchable showMore>
                      {t('SEARCH_PAGE_REFINE_RESULTS_SOURCE', { defaultValue: 'Source' })}
                    </CustomRefinementList>
                  </P2GGrid>
                  <P2GGrid item xs={6}>
                    <CustomRefinementList attribute="deliveryAddress.countryIso3" limit={5} searchable showMore>
                      {t('SEARCH_PAGE_REFINE_RESULTS_DELIVERY_COUNTRY', { defaultValue: 'Delivery Country' })}
                    </CustomRefinementList>
                  </P2GGrid>
                  <P2GGrid item xs={6}>
                    <CustomRefinementList attribute="service.name" limit={5} searchable showMore>
                      {t('SEARCH_PAGE_REFINE_RESULTS_SERVICE', { defaultValue: 'Service' })}
                    </CustomRefinementList>
                  </P2GGrid>
                  <P2GGrid item xs={6}>
                    <CustomRefinementList attribute="trackingStatus" limit={5} searchable showMore>
                      {t('SEARCH_PAGE_REFINE_RESULTS_TRACKING_STATUS', { defaultValue: 'Tracking Status' })}
                    </CustomRefinementList>
                  </P2GGrid>
                </P2GGrid>
              </P2GBox>
            </div>
          )}
          <P2GBox>
            <Hits hit={props.hit} hideFilter={props.hideFilter} />
          </P2GBox>
        </P2GGrid>
      </P2GGrid>
    </InstantSearch>
  );
};

export default SearchPage;
